import TextField from '@/pages/home/components/fields/TextField';
import SelectField from '@/pages/home/components/fields/SelectField';
import ChipsField from '@/pages/home/components/fields/ChipsField';
import MultiChipsField from '@/pages/home/components/fields/MultiChipsField';
import TextAreaField from '@/pages/home/components/fields/TextAreaField';
import type { FieldConfig } from '@/mocks/questionnaire';
import type { Answers } from '@/pages/home/types';

interface FieldRendererProps {
  field: FieldConfig;
  answers: Answers;
  onAnswer: (name: string, value: string | string[]) => void;
}

export default function FieldRenderer({ field, answers, onAnswer }: FieldRendererProps) {
  const raw = answers[field.name];
  const textValue = typeof raw === 'string' ? raw : '';
  const listValue = Array.isArray(raw) ? raw : [];

  if (field.type === 'select') {
    return (
      <SelectField
        field={field}
        value={textValue}
        onChange={(value) => onAnswer(field.name, value)}
      />
    );
  }

  if (field.type === 'chips') {
    return (
      <ChipsField
        field={field}
        value={textValue}
        onChange={(value) => onAnswer(field.name, value)}
      />
    );
  }

  if (field.type === 'multi') {
    return (
      <MultiChipsField
        field={field}
        value={listValue}
        onChange={(value) => onAnswer(field.name, value)}
      />
    );
  }

  if (field.type === 'textarea') {
    return (
      <TextAreaField
        field={field}
        value={textValue}
        onChange={(value) => onAnswer(field.name, value)}
      />
    );
  }

  return (
    <TextField
      field={field}
      value={textValue}
      onChange={(value) => onAnswer(field.name, value)}
    />
  );
}